import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Briefcase } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products')({
    staticData: {
        breadcrumb: {
            title: 'Claims & Products',
            inactive: true,
        },
        permissions: ORG_CONFIG_PERMISSIONS,
        modules: ['claim'],
        ui: {
            icon: Briefcase,
        },
    },
    component: Outlet,
});
